import * as t from './types'
import config from 'config'
import getCookieByName from 'utils/getCookieByName'
import {
  INTERNAL_IP_ADDRESS,
  INTERNAL_TRAFFIC_COOKIE,
  INTERNAL_TRAFFIC_VALUE
} from 'utils/dy-hybrid/constants'

export const API_KEY = config.modules.dyHybrid.apiKey

export function createBody(props: t.DyContext) {
  const body: any = {
    user: {
      dyid: props._dyid_server,
      dyid_server: props._dyid_server,
      active_consent_accepted: props.consentStatus === 'ACCEPTED'
    },
    context: {
      device: {
        userAgent: window.navigator.userAgent
      }
    },
    session: {
      dy: props._dyjsession
    }
  }
  if (props.consentStatus === 'ACCEPTED') {
    if (props._dy_cs_gcg) {
      body.context.pageAttributes = {
        globalControlGroup: props._dy_cs_gcg
      }
    }
  }

  body.context.pageAttributes = {
    ...body.context.pageAttributes,
    customerType:
      getCookieByName(
        config.i18n.country.toLowerCase() + '-channel'
      )?.toUpperCase() || 'undecided',
    returningUser: props.isRetuningUser
  }
  const isInternalTraffic =
    getCookieByName(INTERNAL_TRAFFIC_COOKIE) === INTERNAL_TRAFFIC_VALUE
  if (isInternalTraffic) {
    body.context.device.ip = INTERNAL_IP_ADDRESS
  }
  return body
}

/** @firescoutMockFn dy.fetch */
export async function dyFetch(url: string, options: RequestInit) {
  try {
    const response = await fetch(url, options)
    if (response.status === 204) return null
    try {
      return await response.json()
    } catch {
      // Falls kein gültiges JSON zurückkommt, stillschweigend null liefern
      return null
    }
  } catch {
    // Netzwerk / Abort / andere Fehler -> kein Throw nach außen, einfach null
    return null
  }
}
